export default __webpack_public_path__ + "static/media/NotoSans-Italic.bd8c4f34.woff2";